import React from "react";
import "../../Template02/Combined.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import {
  FaSearch,
  FaFlask,
  FaClipboardList,
  FaIndustry,
  FaHandshake,
  FaCheckCircle,
} from "react-icons/fa";
import { GiArchiveResearch } from "react-icons/gi";
import { BiSolidCustomize } from "react-icons/bi";

function AboutScreen() {
  return (
    <>
      {/* Header */}
      <Header />

      <div>
        <div id="about" className="page wb-page">
          {/* Breadcrumb Section */}
          <section
            id="section-3592583"
            className="breadcrumb-section dark sec-padding-lg"
            style={{
              backgroundImage:
                "url(https://images.pexels.com/photos/9742867/pexels-photo-9742867.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          >
            <div className="container boxWidget">
              <div className="col-lg-6">
                <div className="richTextWidget title-heading">
                  <h1>About Medisol Labs</h1>
                </div>
              </div>
            </div>
          </section>

          {/* Vision Section */}
          <section id="section-3592587" className="widget-section">
            <div className="container boxWidget">
              <div className="row custom-row">
                <div className="col-lg-6 col-sm-8 col-sm-12">
                  <div className="imageWidget">
                    <img
                      className="lazyload curve-img-big"
                      alt="Medisol-Lab research facility"
                      src="//images.pexels.com/photos/9742856/pexels-photo-9742856.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                    />
                  </div>
                  <div className="imageWidget">
                    <img
                      className="lazyload curve-img-sml"
                      alt="Research lab equipment"
                      src="//images.pexels.com/photos/9742780/pexels-photo-9742780.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="richTextWidget para-normal">
                    <h1 style={{ marginTop: 14 }}>Our Vision</h1>
                    <p>
                      At Medisol, we are dedicated to advancing healthcare
                      through cutting-edge research and formulation development.
                      Our vision is to be a leading innovator in medical
                      science, focused on improving patient outcomes by
                      delivering scientifically validated, safe, and effective
                      therapeutic products. We aim to push the boundaries of
                      what is possible in healthcare by combining scientific
                      expertise with rigorous development processes to create
                      the next generation of life-saving medical solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Mission Section */}
          <section
            id="section-3592595"
            className="fun-flix-type widget-section"
          >
            <div className="container boxWidget">
              <div className="row custom-row">
                <div className="col-lg-5">
                  <div className="richTextWidget para-normal">
                    <h1>Our Mission</h1>
                    <p>
                      Our mission at Medisol is to leverage advanced scientific
                      research to develop novel medical formulations that
                      address the unmet needs of patients. We strive to create
                      innovative delivery systems and therapies that improve
                      treatment outcomes, particularly in respiratory care, by
                      developing products that are not only effective but also
                      safe, scalable, and accessible to global markets.
                    </p>
                    <ul>
                      <li>
                        <strong>Inhaler Formulations (MDIs & DPIs):</strong>{" "}
                        Developing precise and reliable formulations for
                        respiratory care that improve patient compliance and
                        therapeutic efficacy.
                      </li>
                      <li>
                        <strong>Innovative Drug Delivery Systems:</strong>{" "}
                        Creating novel drug delivery technologies that enhance
                        the effectiveness of treatments across various
                        therapeutic areas.
                      </li>
                      <li>
                        <strong>Advanced Nasal & Pulmonary Therapies:</strong>{" "}
                        Researching cutting-edge formulations for nasal and
                        pulmonary drug delivery to improve respiratory and
                        systemic health.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-7 item-box-wrapper">
                  {/* Team Images */}
                  <div className="new-item">
                    <div className="imageWidget">
                      <img
                        className="lazyload team-img"
                        alt="Team Member 1"
                        src="//static.sitemantic.com/webbuilder/images/testimonials/img-9.jpg"
                      />
                    </div>
                  </div>
                  <div className="new-item">
                    <div className="imageWidget">
                      <img
                        className="lazyload team-img"
                        alt="Team Member 2"
                        src="//static.sitemantic.com/webbuilder/images/testimonials/img-4.jpg"
                      />
                    </div>
                  </div>
                  <div className="new-item">
                    <div className="imageWidget">
                      <img
                        className="lazyload team-img"
                        alt="Team Member 3"
                        src="//static.sitemantic.com/webbuilder/images/testimonials/img-6.jpg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Our Research Process & Expertise Section */}
          <section id="section-research-process" className="widget-section">
            <div className="container boxWidget">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <div className="richTextWidget head-content">
                    <h1 className="section-title">
                      Our Research Process & Expertise
                    </h1>
                    <p className="section-subtitle">
                      Medisol combines state-of-the-art research techniques with
                      years of expertise in formulation development. Our goal is
                      to transform innovative scientific ideas into effective,
                      safe, and high-quality medical products. Learn more about
                      our multi-phase approach to creating breakthrough medical
                      solutions.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Research Stage 1 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaSearch size={40} color="#4CAF50" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">
                        Discovery & Target Identification
                      </h4>
                      <p className="feature-description">
                        We focus on identifying novel therapeutic targets and
                        developing the foundational science behind breakthrough
                        treatments for a range of diseases.
                      </p>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaSearch size={40} color="#4CAF50" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">Research & Analysis </h4>
                      <p className="feature-description">
                        We employ advanced analytical techniques to validate and
                        enhance our formulations. Our R&D capabilities span
                        molecular characterization, stability studies, and
                        efficacy testing, ensuring reliable results backed by
                        rigorous science.
                      </p>
                    </div>
                  </div>
                </div> */}

                {/* Research Stage 2 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaFlask size={40} color="#2196F3" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">Formulation Development</h4>
                      <p className="feature-description">
                        Our formulation scientists work to optimize active
                        ingredients, ensuring their stability, bioavailability,
                        and effectiveness in clinical settings.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Research Stage 3 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaClipboardList size={40} color="#FF9800" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">
                        Preclinical & Clinical Trials
                      </h4>
                      <p className="feature-description">
                        Our formulations undergo rigorous testing in preclinical
                        and clinical trials to ensure they are safe, effective,
                        and compliant with global standards.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Research Stage 4 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaIndustry size={40} color="#FF5722" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">
                        Scale-Up & Manufacturing
                      </h4>
                      <p className="feature-description">
                        We scale-up our successful formulations into full-scale
                        production while ensuring compliance with international
                        regulatory standards.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Research Stage 5 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaHandshake size={40} color="#8BC34A" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">
                        Partnerships & Licensing
                      </h4>
                      <p className="feature-description">
                        Medisol actively collaborates with pharmaceutical
                        companies and other partners to bring innovative
                        formulations to the global market.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Research Stage 6 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaCheckCircle size={40} color="#9C27B0" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">Final Approval & Launch</h4>
                      <p className="feature-description">
                        Our formulations undergo thorough regulatory reviews
                        before they are approved for market launch, ensuring
                        safety, quality, and efficacy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Research Stage 7 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <GiArchiveResearch size={40} color="#333399" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">Research & Analysis </h4>
                      <p className="feature-description">
                        We employ advanced analytical techniques to validate and
                        enhance our formulations. Our R&D capabilities span
                        molecular characterization, stability studies, and
                        efficacy testing, ensuring reliable results backed by
                        rigorous science.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Research Stage 8 */}
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <BiSolidCustomize size={40} color="#2196F3" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">Custom Solutions</h4>
                      <p className="feature-description">
                        Each project is unique, and so are our solutions. We
                        collaborate closely with our partners to understand
                        their goals, delivering bespoke formulations and
                        insights that drive success.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Research Stage 3 */}
                {/* <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="feature-card">
                    <div className="iconWidget text-center">
                      <FaClipboardList size={40} color="#FF9800" />
                    </div>
                    <div className="richTextWidget feature-content text-center">
                      <h4 className="feature-title">
                        Preclinical & Clinical Trials
                      </h4>
                      <p className="feature-description">
                        Our formulations undergo rigorous testing in preclinical and clinical trials to ensure they are safe, effective, and compliant with global standards.
                      </p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default AboutScreen;
